export default "__VITE_ASSET__hsPFmO2z__"